import { useBilling } from "../Kitchen/billingProvider";
import { Table } from "react-bootstrap";
import { useCurrency } from "../../provider/courtryProvider";
import { useSelector } from "react-redux";
import DeleteIcon from "@material-ui/icons/Delete";
import scanimg from "../image/barcodescan.png";
import BillingFooter from "./billingFooter";
import GenerateBtn from "./generateBillBtn";
import { startCase, camelCase } from "lodash";
import { useAccess } from "../../provider/AccessProvider";
import { GENERATEBILLACCESS } from "../../utils/constant";
import { App, theme } from "antd";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const CurrentTabItem = () => {
  const currencyFormatter = useCurrency();
  const taxList = useSelector((state) => state.taxList.taxList);
  const invoiceSettings = useSelector(
    (state) => state.newInvoicesettings.newInvoicesettings
  );
  const navigate = useNavigate();
  const access = useAccess(GENERATEBILLACCESS);
  const { modal: toastModal } = App.useApp();
  const { useToken } = theme;
  const {
    token: { colorPrimary },
  } = useToken();
  const {
    state: { addedProducts, b2bBill },
    updateProductPriceFromProduct,
    removeProductFromBilling,
    updateProductQuantityFromProduct,
  } = useBilling();

  useEffect(() => {
    if (!access.generateBill(false)) {
      toastModal.error({
        title: "Access Denied",
        content:
          "You do not have access for generate bill. Please contact your administrator to request the appropriate access.",
        width: 500,
        okButtonProps: {
          type: "primary",
          style: {
            background: colorPrimary,
          },
        },
        onOk: () => {
          navigate("/dashboard");
          return false;
        },
        closable: false,
      });
    }
  }, []);

  return (
    <>
      <div
        className="product-table"
        style={{ background: "#feffff", position: "relative" }}
      >
        <div
          className="product-table-header"
          style={{
            background: "#feffff",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div style={{ display: "flex" }}>
            <div className="product-table-header-order">
              <p>Order Items ({addedProducts.length})</p>
            </div>
            {/* <div className="product-table-header-line">
                <p>|</p>
              </div> */}
            {/* <div className="product-table-header-invoice">
                <p>
                  Invoice No: {invoiceSettings.invoicePrefixtext}
                  {invoiceSettings.currentInvoiceNumber}
                </p>
              </div> */}
          </div>
        </div>
        {addedProducts.length > 0 ? (
          <Table responsive="md">
            <thead>
              <tr>
                <th
                  style={{
                    verticalAlign: "middle",
                    fontWeight: "500",
                  }}
                >
                  Item
                </th>
                {invoiceSettings.itemmrp && (
                  <th
                    style={{
                      verticalAlign: "middle",
                      fontWeight: "500",
                    }}
                  >
                    MRP
                  </th>
                )}
                <th
                  style={{
                    verticalAlign: "middle",
                    fontWeight: "500",
                  }}
                >
                  Rate
                </th>
                <th
                  style={{
                    verticalAlign: "middle",
                    fontWeight: "500",
                  }}
                >
                  Qty.
                </th>
                {/* {billLineSettings.itemWastage && (
                    <th
                      style={{
                        verticalAlign: "middle",
                        fontWeight: "500",
                      }}
                    >
                      Wast.(%)
                    </th>
                  )}
                  {billLineSettings.itemLabour && (
                    <th
                      style={{
                        verticalAlign: "middle",
                        fontWeight: "500",
                      }}
                    >
                      Labour(%)
                    </th>
                  )} */}
                {invoiceSettings.hsncode && (
                  <th
                    style={{
                      verticalAlign: "middle",
                      fontWeight: "500",
                    }}
                  >
                    HSN
                  </th>
                )}
                {invoiceSettings.itemleveltax && (
                  <>
                    <th
                      style={{
                        verticalAlign: "middle",
                        fontWeight: "500",
                        textAlign: "center",
                      }}
                    >
                      Tax(%)
                    </th>
                    <th
                      style={{
                        verticalAlign: "middle",
                        fontWeight: "500",
                        width: "150px",
                      }}
                    >
                      Inclusive/Exclusive
                    </th>
                  </>
                )}
                <th
                  style={{
                    verticalAlign: "middle",
                    fontWeight: "500",
                  }}
                >
                  Subtotal
                </th>
                <th
                  style={{
                    verticalAlign: "middle",
                    fontWeight: "500",
                  }}
                ></th>
              </tr>
            </thead>
            <tbody>
              {addedProducts.map((data, index) => {
                return (
                  <tr
                    key={data.productId}
                    className="align-items-center"
                    style={{
                      background: "#feffff",
                      verticalAlign: "middle",
                    }}
                  >
                    <td
                      style={{
                        verticalAlign: "middle",
                        position: "relative",
                      }}
                    >
                      <div className="productname-input">
                        <p>{data.productName}</p>
                        <h6>{data.unitOfMeasurment}</h6>
                        {parseFloat(data.productPrice) >
                          parseFloat(data.productMrp) && (
                          <small
                            style={{
                              color: "rgb(240,66,9)",
                              marginTop: "-0.5rem",
                              textAlign: "left",
                              whiteSpace: "nowrap",
                            }}
                          >
                            Selling price greater than mrp
                          </small>
                        )}
                        {parseFloat(data.itemTotal) >
                          parseFloat(data.productMrp) *
                            parseFloat(data.count) && (
                          <small
                            style={{
                              color: "rgb(240,66,9)",
                              marginTop: "-0.3rem",
                              textAlign: "left",
                              whiteSpace: "nowrap",
                            }}
                          >
                            Sub Total greater than mrp
                          </small>
                        )}
                      </div>
                    </td>
                    {invoiceSettings.itemmrp && (
                      <td
                        style={{
                          verticalAlign: "middle",
                          textAlign: "left",
                        }}
                      >
                        <p>
                          {data.productMrp
                            ? parseFloat(data.productMrp).toFixed(2)
                            : "0.00"}
                        </p>
                      </td>
                    )}
                    <td
                      style={{
                        verticalAlign: "middle",
                      }}
                    >
                      <p style={{ textAlign: "left" }}>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            borderBottom: "0.2px dashed #000000",
                            width: "80px",
                            backgroundColor: "white",
                          }}
                        >
                          <input
                            placeholder="Price"
                            style={{
                              width: "80px",
                            }}
                            value={data.productPrice}
                            type="number"
                            name="productPrice"
                            onWheel={(e) => e.target.blur()}
                            onChange={(e) => {
                              if (!access.editPricing()) {
                                return;
                              }
                              updateProductPriceFromProduct(
                                data,
                                e.target.value
                              );
                            }}
                          />
                        </div>
                        {/* {data.productPrice
                            ? parseFloat(data.productPrice).toFixed(2)
                            : "0.00"} */}
                      </p>
                      {invoiceSettings.itemdiscount && (
                        <p>
                          {data.discountPrice ? (
                            data.discountType ? (
                              data.discountType === "flat" ? (
                                <p
                                  style={{
                                    width: "max-content",
                                    whiteSpace: "nowrap",
                                  }}
                                  className="ratecolor"
                                >
                                  -{currencyFormatter(data.discountPrice)}
                                </p>
                              ) : (
                                <p className="ratecolor">
                                  -{data.discountPrice}%
                                </p>
                              )
                            ) : (
                              <></>
                            )
                          ) : (
                            <></>
                          )}
                        </p>
                      )}
                    </td>
                    <td style={{ verticalAlign: "middle" }}>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          borderBottom: "0.2px dashed #000000",
                          width: "50px",
                          backgroundColor: "white",
                        }}
                      >
                        <input
                          placeholder="Qty"
                          value={data.count}
                          name="count"
                          type="number"
                          style={{
                            width: 70,
                          }}
                          onWheel={(e) => e.target.blur()}
                          onChange={(e) => {
                            updateProductQuantityFromProduct(
                              data,
                              e.target.value
                            );
                          }}
                        />
                      </div>
                    </td>
                    {/* {billLineSettings.itemWastage && (
                        <td style={{ verticalAlign: "middle" }}>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <div>
                              {data.productWastage
                                ? data.productWastage
                                : "0%"}
                            </div>
                          </div>
                        </td>
                      )} */}
                    {/* {billLineSettings.itemLabour && (
                        <td style={{ verticalAlign: "middle" }}>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <div>
                              {data.productLabour
                                ? data.productLabour
                                : "0%"}
                            </div>
                          </div>
                        </td>
                      )} */}
                    {invoiceSettings.hsncode && (
                      <td style={{ verticalAlign: "middle" }}>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <div>
                            {data.productHsnCode ? (
                              <>{data.productHsnCode}</>
                            ) : (
                              "Nil"
                            )}
                          </div>
                        </div>
                      </td>
                    )}
                    {invoiceSettings.itemleveltax && (
                      <td
                        style={{
                          verticalAlign: "middle",
                        }}
                      >
                        {data.taxId ? (
                          taxList.map((tax) => {
                            return (
                              <span key={tax.taxId}>
                                {tax.taxId === data.taxId && tax.taxName}
                              </span>
                            );
                          })
                        ) : (
                          //   <select
                          //   name="taxId"
                          //   style={{
                          //     fontSize: 15,
                          //     marginRight: 10,
                          //     height: "32px",
                          //     width: "150px",
                          //   }}
                          //   value={data.taxId}
                          //   onChange={(e) =>
                          //     handleBillingInputChange(
                          //       e.target.name,
                          //       e.target.value,
                          //       data,
                          //       index
                          //     )
                          //   }
                          //   disabled={true}
                          // >
                          //   <option value={""}>Select Tax</option>
                          //   {taxList.map((tax) => {
                          //     return (
                          //       <option
                          //         key={tax.taxId}
                          //         value={tax.taxId}
                          //       >
                          //         {tax.taxName}
                          //       </option>
                          //     );
                          //   })}
                          // </select>
                          <span>{data.productTax}</span>
                        )}
                      </td>
                    )}
                    {invoiceSettings.itemleveltax && (
                      <td style={{ verticalAlign: "middle" }}>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          {data?.taxIncExc !== "Inclusive/Exclusive" &&
                            startCase(camelCase(data?.taxIncExc))}
                        </div>
                      </td>
                    )}
                    <td style={{ verticalAlign: "middle" }}>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <div>{currencyFormatter(data.itemTotal)}</div>
                        {/* <div
                              onClick={() =>
                                deleteItemHandler(data.productId)
                              }
                            >
                              {parseFloat(data.itemTotal) === 0 && (
                                <small
                                  style={{
                                    color: "rgb(240,66,9)",
                                    marginTop: "-0.5rem",
                                    textAlign: "left",
                                    whiteSpace: "nowrap",
                                    marginLeft: "8px",
                                  }}
                                >
                                  Delete item or Change Value
                                </small>
                              )}
                            </div> */}
                      </div>
                    </td>
                    {parseFloat(data.itemTotal) === 0 && (
                      <td style={{ verticalAlign: "middle" }}>
                        <button
                          style={{
                            cursor: "pointer",
                            border: 0,
                            boxShadow: "none",
                            background: "none",
                          }}
                          onClick={() =>
                            removeProductFromBilling(data.productId)
                          }
                        >
                          <DeleteIcon style={{ color: "red" }} />
                        </button>
                      </td>
                    )}
                    {parseFloat(data.itemTotal) !== 0 && (
                      <td style={{ verticalAlign: "middle" }}>
                        <button
                          style={{
                            cursor: "pointer",
                            border: 0,
                            boxShadow: "none",
                            background: "none",
                          }}
                          onClick={() =>
                            removeProductFromBilling(data.productId)
                          }
                        >
                          <DeleteIcon />
                        </button>
                      </td>
                    )}
                  </tr>
                );
              })}
            </tbody>
          </Table>
        ) : (
          <div className="noItemDiv">
            <div className="noItemimg">
              <img src={scanimg} width="50px" height="51px" />
            </div>
            <p className="noItemText" style={{ marginTop: 0 }}>
              Start billing your items by scanning or add items from inventory
              using search
            </p>
          </div>
        )}
      </div>
      <BillingFooter />
      <GenerateBtn />
    </>
  );
};

export default CurrentTabItem;
